import { COLORS } from "../../../../Diathrive/src/utils/Constants";

const styles = {
  headerContainer: {
    display: "flex",
    gridTemplateColumns: "auto auto",
    background: COLORS.white,
    borderBottom: `1px solid ${COLORS.greyLight}`,
    minHeight: "84px",
  },
  headerTitle: {
    display: "flex",
    flex: 1,
    alignContent: "start",
    alignItems: "center",
    marginLeft: "32px",
    marginRight: "32px",
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    alignContent: "end",
    gap: "25px",
    marginRight: "32px",
  },
  manualInput: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px 14px",
    gap: "14px",
    width: "156px",
    height: "48px",
    background: `${COLORS.white}`,
    border: `2px solid ${COLORS.greyBackground}`,
    borderRadius: "16px",
    flex: "none",
    order: 0,
    flexGrow: 0,
  },
  cartIcon: {
    justifyContent: "center",
    alignItems: "center",
    width: "48px",
    height: "48px",
    padding: "14px 16px",
    background: `${COLORS.white}`,
    border: `2px solid ${COLORS.greyBackground}`,
    borderRadius: "16px",
  },
  cartStatusDot: {
    height: 12,
    width: 12,
    borderRadius: 6,
    backgroundColor: COLORS.pink,
    borderWidth: 2,
    borderColor: COLORS.white,
    position: "absolute",
    bottom: 0,
    right: 0,
  },
};

export default styles;
